import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import styles from './ScheduledMessagesEmpty.styles.m.css';

export const ScheduledMessagesEmpty: FC = () => {
  const { t } = useTranslation();

  return (
    <InfoBlock
      className={styles.infoBlock}
      type={InfoBlockTypes.Chat}
      descriptions={[t('no_schedule_messages')]}
      image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.notFound)}
    />
  );
};
